import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { QuizOffer } from 'src/types/marketplace';

export type Recommendations = QuizOffer[];
const initialState: Recommendations = [];

const recommendations = createSlice({
  name: 'recommendations',
  initialState,
  reducers: {
    setRecommendations(state, action: PayloadAction<Recommendations>) {
      return action.payload;
    },
  },
});

export const { setRecommendations } = recommendations.actions;
export default recommendations.reducer;
